import {ceil, range} from 'lodash'
import {useMemo} from 'react'

export const Pagination = props => {
  const {total, limit, page, setPage, sm, ...otherProps} = props

  const pages = useMemo(() => {
    return ceil(total / limit)
  }, [limit, total])

  const shouldRender = useMemo(() => {
    return pages > 1
  }, [pages])

  const hasNextPage = useMemo(() => {
    return pages > page
  }, [page, pages])

  const hasPreviousPage = useMemo(() => {
    return page > 1
  }, [page])

  const className = useMemo(() => {
    return sm ? 'btn-group btn-group-sm' : 'btn-group'
  }, [sm])

  return shouldRender ? (
    <div {...otherProps}>
      <div className={className} role="group">
        {hasPreviousPage && (
          <button
            className="btn border btn-light"
            onClick={() => setPage(page - 1)}
          >
            <i className="fal fa-chevron-left"></i>
          </button>
        )}

        {range(1, pages + 1).map(
          pageNumber => (
            <button
              key={`pagination-${pageNumber}`}
              type="button"
              className={`btn border ${pageNumber === page ? 'btn-primary' : 'btn-light'}`}
              onClick={() => setPage(pageNumber)}
            >
              {pageNumber}
            </button>
          )
        )}

        {hasNextPage && (
          <button
            className="btn border btn-light"
            onClick={() => setPage(page + 1)}
          >
            <i className="fal fa-chevron-right"></i>
          </button>
        )}
      </div>
    </div>
  ) : null
}
